// // // src/pages/Dashboard/vendor-balance/components/VendorTopOutstanding.jsx
// // import React, { useState } from 'react';
// // import styles from './VendorTopOutstanding.module.css';
// // import { vendorBalanceApi } from '../../../../api/vendor-balance/vendorBalanceApi';
// // import * as XLSX from 'xlsx';

// // const VendorTopOutstanding = () => {
// //   const [searchTerm, setSearchTerm] = useState('');
// //   const [vendors, setVendors] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [hasSearched, setHasSearched] = useState(false);

// //   const handleSearch = async () => {
// //     if (!searchTerm.trim()) return;
// //     try {
// //       setLoading(true);
// //       setError(null);
// //       setHasSearched(true);
// //       const data = await vendorBalanceApi.getTopOutstanding(searchTerm.trim());
// //       setVendors(data);
// //     } catch (err) {
// //       setError('Failed to fetch vendor data');
// //       setVendors([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleClear = () => {
// //     setSearchTerm('');
// //     setVendors([]);
// //     setHasSearched(false);
// //     setError(null);
// //   };

// //   const handleExportExcel = () => {
// //     if (vendors.length === 0) { alert('No data to export'); return; }
// //     const exportData = vendors.map((v, i) => ({
// //       'Rank': i + 1,
// //       'Vendor Code': v.vendorCode,
// //       'Vendor Name': v.vendorName,
// //       'Country': v.country,
// //       'State': v.state,
// //       'Region': v.region || 'Unknown',
// //       'Total Outstanding': v.totalOutstanding,
// //       'Overdue Amount': v.overdueAmount
// //     }));
// //     const worksheet = XLSX.utils.json_to_sheet(exportData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendor Outstanding');
// //     XLSX.writeFile(workbook, `vendor_outstanding_${searchTerm.replace(/\s+/g, '_')}.xlsx`);
// //   };

// //   const formatCurrency = (amount) =>
// //     '₹' + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// //   const totalOutstanding = vendors.reduce((sum, v) => sum + v.totalOutstanding, 0);
// //   const totalOverdue = vendors.reduce((sum, v) => sum + (v.overdueAmount || 0), 0);

// //   return (
// //     <div className={styles.wrapper}>
// //       <div className={styles.header}>
// //         <h2 className={styles.pageTitle}>Top Outstanding Vendors</h2>
// //       </div>

// //       {/* Search bar */}
// //       <div className={styles.filtersSection}>
// //         <div className={styles.searchRow}>
// //           <div className={styles.searchInputWrapper}>
// //             <span className={styles.searchIcon}>🔍</span>
// //             <input
// //               type="text"
// //               placeholder="Search vendor name..."
// //               value={searchTerm}
// //               onChange={(e) => setSearchTerm(e.target.value)}
// //               onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
// //               className={styles.searchInput}
// //               disabled={loading}
// //             />
// //             {searchTerm && (
// //               <button onClick={handleClear} className={styles.clearSearchButton} title="Clear">✕</button>
// //             )}
// //           </div>
// //           <button onClick={handleSearch} disabled={loading || !searchTerm.trim()} className={styles.searchButton}>
// //             Search
// //           </button>
// //           {vendors.length > 0 && (
// //             <button onClick={handleExportExcel} disabled={loading} className={styles.excelButton}>
// //               📊 Export Excel
// //             </button>
// //           )}
// //         </div>

// //         {/* Summary row */}
// //         {vendors.length > 0 && (
// //           <div className={styles.summaryRow}>
// //             <div className={styles.summaryText}>
// //               Found <strong>{vendors.length}</strong> vendor{vendors.length !== 1 ? 's' : ''}
// //             </div>
// //             <div className={styles.totalAmounts}>
// //               <div className={styles.totalOverdue}>
// //                 Total Overdue: <span className={styles.amountRed}>{formatCurrency(totalOverdue)}</span>
// //               </div>
// //               <div className={styles.totalOutstanding}>
// //                 Total Balance: <span className={styles.amountBlue}>{formatCurrency(totalOutstanding)}</span>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>

// //       {error && <div className={styles.errorMessage}>{error}</div>}

// //       {loading && (
// //         <div className={styles.loadingContainer}>
// //           <div className={styles.loadingSpinner} />
// //           <div className={styles.loadingText}>Searching vendors...</div>
// //         </div>
// //       )}

// //       {/* Empty state - before search */}
// //       {!loading && !hasSearched && (
// //         <div className={styles.emptyState}>
// //           <div className={styles.emptyIcon}>🏢</div>
// //           <h3 className={styles.emptyTitle}>Search for a Vendor</h3>
// //           <p className={styles.emptyText}>Type a vendor name above to view their outstanding balance details</p>
// //         </div>
// //       )}

// //       {/* Empty state - after search with no results */}
// //       {!loading && hasSearched && vendors.length === 0 && (
// //         <div className={styles.emptyState}>
// //           <div className={styles.emptyIcon}>📊</div>
// //           <h3 className={styles.emptyTitle}>No Vendors Found</h3>
// //           <p className={styles.emptyText}>No vendors match your search term</p>
// //         </div>
// //       )}

// //       {/* Results table */}
// //       {!loading && vendors.length > 0 && (
// //         <div className={styles.tableContainer}>
// //           <div className={styles.tableWrapper}>
// //             <table className={styles.table}>
// //               <thead>
// //                 <tr>
// //                   <th className={styles.th}>#</th>
// //                   <th className={styles.th}>Vendor Code</th>
// //                   <th className={styles.th}>Vendor Name</th>
// //                   <th className={styles.th}>Country</th>
// //                   <th className={styles.th}>State</th>
// //                   <th className={styles.th}>Region</th>
// //                   <th className={`${styles.th} ${styles.thRight}`}>Overdue Amount</th>
// //                   <th className={`${styles.th} ${styles.thRight}`}>Total Outstanding</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {vendors.map((v, index) => (
// //                   <tr key={`${v.vendorCode}-${index}`} className={styles.tr}>
// //                     <td className={styles.td}><span className={styles.rank}>#{index + 1}</span></td>
// //                     <td className={styles.td}><span className={styles.vendorCode}>{v.vendorCode}</span></td>
// //                     <td className={styles.td}><span className={styles.vendorName}>{v.vendorName}</span></td>
// //                     <td className={styles.td}>{v.country || 'N/A'}</td>
// //                     <td className={styles.td}>{v.state || 'N/A'}</td>
// //                     <td className={styles.td}>
// //                       <span className={`${styles.regionBadge} ${v.region ? styles.regionBadgeFilled : styles.regionBadgeEmpty}`}>
// //                         {v.region || 'Unknown'}
// //                       </span>
// //                     </td>
// //                     <td className={`${styles.td} ${styles.tdRight}`}>
// //                       <span className={`${styles.overdueAmount} ${(v.overdueAmount || 0) > 0 ? styles.overdueAmountActive : ''}`}>
// //                         {formatCurrency(v.overdueAmount || 0)}
// //                       </span>
// //                     </td>
// //                     <td className={`${styles.td} ${styles.tdRight}`}>
// //                       <span className={styles.outstandingAmount}>{formatCurrency(v.totalOutstanding)}</span>
// //                     </td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default VendorTopOutstanding;

// // src/pages/Dashboard/vendor-balance/components/VendorTopOutstanding.jsx
// import React, { useState, useRef, useEffect } from 'react';
// import styles from './VendorTopOutstanding.module.css';
// import { vendorBalanceApi } from '../../../../api/vendor-balance/vendorBalanceApi';
// import * as XLSX from 'xlsx';

// const VendorTopOutstanding = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [suggestions, setSuggestions] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [selectedVendor, setSelectedVendor] = useState(null);
//   const [vendors, setVendors] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [suggestionsLoading, setSuggestionsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [hasSearched, setHasSearched] = useState(false);

//   const dropdownRef = useRef(null);
//   const debounceRef = useRef(null);

//   // Close dropdown on outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Debounced suggestion fetch
//   useEffect(() => {
//     if (!searchTerm.trim() || selectedVendor) {
//       setSuggestions([]);
//       setShowDropdown(false);
//       return;
//     }

//     // Debounce — wait 300ms after user stops typing
//     clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(async () => {
//       try {
//         setSuggestionsLoading(true);
//         const data = await vendorBalanceApi.getTopOutstanding(searchTerm.trim());
//         // Extract unique vendor names + codes for dropdown
//         const unique = [];
//         const seen = new Set();
//         data.forEach(v => {
//           if (!seen.has(v.vendorCode)) {
//             seen.add(v.vendorCode);
//             unique.push({ vendorCode: v.vendorCode, vendorName: v.vendorName });
//           }
//         });
//         setSuggestions(unique.slice(0, 10)); // max 10 suggestions
//         setShowDropdown(true);
//       } catch (err) {
//         setSuggestions([]);
//       } finally {
//         setSuggestionsLoading(false);
//       }
//     }, 300);

//     return () => clearTimeout(debounceRef.current);
//   }, [searchTerm, selectedVendor]);

//   const handleInputChange = (e) => {
//     setSearchTerm(e.target.value);
//     setSelectedVendor(null); // clear selection when typing
//     setVendors([]);
//     setHasSearched(false);
//   };

//   const handleSuggestionSelect = async (suggestion) => {
//     setSearchTerm(suggestion.vendorName);
//     setSelectedVendor(suggestion);
//     setShowDropdown(false);
//     setSuggestions([]);
//     await fetchOutstanding(suggestion.vendorName);
//   };

//   const fetchOutstanding = async (name) => {
//     try {
//       setLoading(true);
//       setError(null);
//       setHasSearched(true);
//       const data = await vendorBalanceApi.getTopOutstanding(name);
//       setVendors(data);
//     } catch (err) {
//       setError('Failed to fetch vendor data');
//       setVendors([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = async () => {
//     if (!searchTerm.trim()) return;
//     setShowDropdown(false);
//     await fetchOutstanding(searchTerm.trim());
//   };

//   const handleClear = () => {
//     setSearchTerm('');
//     setSelectedVendor(null);
//     setVendors([]);
//     setSuggestions([]);
//     setHasSearched(false);
//     setError(null);
//     setShowDropdown(false);
//   };

//   const handleExportExcel = () => {
//     if (vendors.length === 0) { alert('No data to export'); return; }
//     const exportData = vendors.map((v, i) => ({
//       'Rank': i + 1,
//       'Vendor Code': v.vendorCode,
//       'Vendor Name': v.vendorName,
//       'Country': v.country,
//       'State': v.state,
//       'Region': v.region || 'Unknown',
//       'Total Outstanding': v.totalOutstanding,
//       'Overdue Amount': v.overdueAmount
//     }));
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendor Outstanding');
//     XLSX.writeFile(workbook, `vendor_outstanding_${searchTerm.replace(/\s+/g, '_')}.xlsx`);
//   };

//   const formatCurrency = (amount) =>
//     '₹' + (amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//   const totalOutstanding = vendors.reduce((sum, v) => sum + v.totalOutstanding, 0);
//   const totalOverdue = vendors.reduce((sum, v) => sum + (v.overdueAmount || 0), 0);

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.header}>
//         <h2 className={styles.pageTitle}>Top Outstanding Vendors</h2>
//       </div>

//       {/* Search */}
//       <div className={styles.filtersSection}>
//         <div className={styles.searchRow}>

//           {/* Input + dropdown */}
//           <div className={styles.searchGroup} ref={dropdownRef}>
//             <label className={styles.filterLabel}>Search Vendor:</label>
//             <div className={styles.searchInputWrapper}>
//               <span className={styles.searchIcon}>🔍</span>
//               <input
//                 type="text"
//                 placeholder="Type vendor name..."
//                 value={searchTerm}
//                 onChange={handleInputChange}
//                 onFocus={() => suggestions.length > 0 && setShowDropdown(true)}
//                 onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//                 className={styles.searchInput}
//                 disabled={loading}
//               />
//               {searchTerm && (
//                 <button onClick={handleClear} className={styles.clearSearchButton} title="Clear">✕</button>
//               )}

//               {/* Dropdown */}
//               {showDropdown && (
//                 <div className={styles.dropdownMenu}>
//                   {suggestionsLoading && (
//                     <div className={styles.dropdownLoading}>Searching...</div>
//                   )}
//                   {!suggestionsLoading && suggestions.length > 0 && suggestions.map((s) => (
//                     <div
//                       key={s.vendorCode}
//                       onClick={() => handleSuggestionSelect(s)}
//                       className={`${styles.dropdownItem} ${selectedVendor?.vendorCode === s.vendorCode ? styles.dropdownItemActive : ''}`}
//                     >
//                       <div className={styles.dropdownItemName}>{s.vendorName}</div>
//                       <div className={styles.dropdownItemCode}>Code: {s.vendorCode}</div>
//                     </div>
//                   ))}
//                   {!suggestionsLoading && suggestions.length === 0 && searchTerm && (
//                     <div className={styles.dropdownNoResults}>No vendors found</div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className={styles.buttonGroup}>
//             <button
//               onClick={handleSearch}
//               disabled={loading || !searchTerm.trim()}
//               className={styles.searchButton}
//             >
//               Search
//             </button>
//             {vendors.length > 0 && (
//               <button onClick={handleExportExcel} disabled={loading} className={styles.excelButton}>
//                 📊 Export Excel
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Summary row */}
//         {vendors.length > 0 && (
//           <div className={styles.summaryRow}>
//             <div className={styles.summaryText}>
//               Found <strong>{vendors.length}</strong> vendor{vendors.length !== 1 ? 's' : ''}
//             </div>
//             <div className={styles.totalAmounts}>
//               <div className={styles.totalOverdue}>
//                 Total Overdue: <span className={styles.amountRed}>{formatCurrency(totalOverdue)}</span>
//               </div>
//               <div className={styles.totalOutstanding}>
//                 Total Balance: <span className={styles.amountBlue}>{formatCurrency(totalOutstanding)}</span>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {error && <div className={styles.errorMessage}>{error}</div>}

//       {loading && (
//         <div className={styles.loadingContainer}>
//           <div className={styles.loadingSpinner} />
//           <div className={styles.loadingText}>Searching vendors...</div>
//         </div>
//       )}

//       {/* Empty — before search */}
//       {!loading && !hasSearched && (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyIcon}>🏢</div>
//           <h3 className={styles.emptyTitle}>Search for a Vendor</h3>
//           <p className={styles.emptyText}>Type a vendor name above to view outstanding balance details</p>
//         </div>
//       )}

//       {/* Empty — after search */}
//       {!loading && hasSearched && vendors.length === 0 && (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyIcon}>📊</div>
//           <h3 className={styles.emptyTitle}>No Vendors Found</h3>
//           <p className={styles.emptyText}>No vendors match your search term</p>
//         </div>
//       )}

//       {/* Results table */}
//       {!loading && vendors.length > 0 && (
//         <div className={styles.tableContainer}>
//           <div className={styles.tableWrapper}>
//             <table className={styles.table}>
//               <thead>
//                 <tr>
//                   <th className={styles.th}>#</th>
//                   <th className={styles.th}>Vendor Code</th>
//                   <th className={styles.th}>Vendor Name</th>
//                   <th className={styles.th}>Country</th>
//                   <th className={styles.th}>State</th>
//                   <th className={styles.th}>Region</th>
//                   <th className={`${styles.th} ${styles.thRight}`}>Overdue Amount</th>
//                   <th className={`${styles.th} ${styles.thRight}`}>Total Outstanding</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {vendors.map((v, index) => (
//                   <tr key={`${v.vendorCode}-${index}`} className={styles.tr}>
//                     <td className={styles.td}><span className={styles.rank}>#{index + 1}</span></td>
//                     <td className={styles.td}><span className={styles.vendorCode}>{v.vendorCode}</span></td>
//                     <td className={styles.td}><span className={styles.vendorName}>{v.vendorName}</span></td>
//                     <td className={styles.td}>{v.country || 'N/A'}</td>
//                     <td className={styles.td}>{v.state || 'N/A'}</td>
//                     <td className={styles.td}>
//                       <span className={`${styles.regionBadge} ${v.region ? styles.regionBadgeFilled : styles.regionBadgeEmpty}`}>
//                         {v.region || 'Unknown'}
//                       </span>
//                     </td>
//                     <td className={`${styles.td} ${styles.tdRight}`}>
//                       <span className={`${styles.overdueAmount} ${(v.overdueAmount || 0) > 0 ? styles.overdueAmountActive : ''}`}>
//                         {formatCurrency(v.overdueAmount || 0)}
//                       </span>
//                     </td>
//                     <td className={`${styles.td} ${styles.tdRight}`}>
//                       <span className={styles.outstandingAmount}>{formatCurrency(v.totalOutstanding)}</span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default VendorTopOutstanding;

// src/pages/Dashboard/vendor-balance/components/VendorTopOutstanding.jsx
import React, { useState, useRef, useEffect } from 'react';
import styles from './VendorTopOutstanding.module.css';
import { vendorBalanceApi } from '../../../../api/vendor-balance/vendorBalanceApi';
import * as XLSX from 'xlsx';

const TABS = [
  { key: 'search',   label: 'Top Outstanding' },
  { key: 'local',    label: 'Local Vendor' },
  { key: 'overseas', label: 'Overseas Vendor' },
];

// ─────────────────────────────────────────────────────────────
// Invoice Modal — opens on row click, shows paginated invoices
// ─────────────────────────────────────────────────────────────
const InvoiceModal = ({ vendor, onClose }) => {
  const [allInvoices, setAllInvoices]       = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [displayInvoices, setDisplayInvoices]   = useState([]);
  const [searchTerm, setSearchTerm]         = useState('');
  const [currentPage, setCurrentPage]       = useState(0);
  const [loading, setLoading]               = useState(true);
  const [error, setError]                   = useState(null);
  const itemsPerPage = 20;

  useEffect(() => {
    fetchInvoices();
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => { applyFilter(); }, [allInvoices, searchTerm, currentPage]);

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const data = await vendorBalanceApi.exportVendorBalances('');
      const matched = data.filter(inv =>
        inv.vendorName?.toLowerCase() === vendor.vendorName?.toLowerCase()
      );
      setAllInvoices(matched);
    } catch { setError('Failed to load invoices'); }
    finally { setLoading(false); }
  };

  const applyFilter = () => {
    let filtered = [...allInvoices];
    if (searchTerm.trim()) {
      const s = searchTerm.toLowerCase();
      filtered = filtered.filter(inv =>
        inv.invoiceNo?.toString().includes(s) ||
        inv.vendorRefNo?.toLowerCase().includes(s) ||
        inv.contactPerson?.toLowerCase().includes(s) ||
        inv.paymentTerms?.toLowerCase().includes(s) ||
        inv.salesPerson?.toLowerCase().includes(s) ||
        inv.region?.toLowerCase().includes(s) ||
        inv.balanceDue?.toString().includes(s) ||
        inv.overdueDays?.toString().includes(s)
      );
    }
    setFilteredInvoices(filtered);
    const start = currentPage * itemsPerPage;
    setDisplayInvoices(filtered.slice(start, start + itemsPerPage));
  };

  const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);

  const handleExport = () => {
    const exportData = filteredInvoices.map(inv => ({
      'Invoice No': inv.invoiceNo, 'Invoice Date': inv.invoiceDate,
      'Vendor Ref No': inv.vendorRefNo, 'Vendor Code': inv.vendorCode,
      'Vendor Name': inv.vendorName, 'Contact Person': inv.contactPerson,
      'Invoice Total': inv.invoiceTotal, 'Balance Due': inv.balanceDue,
      'Country': inv.country, 'State': inv.state, 'Region': inv.region,
      'Overdue Days': inv.overdueDays, 'Payment Terms': inv.paymentTerms,
      'Supply Date': inv.supplyDate, 'Sales Person': inv.salesPerson,
      'Master Sales Person': inv.masterSalesPerson, 'Payment Status': inv.paymentStatus,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Invoices');
    XLSX.writeFile(wb, `invoices_${vendor.vendorName.replace(/\s+/g, '_')}.xlsx`);
  };

  const formatCurrency = (v) => '₹' + (v || 0).toLocaleString('en-IN');
  const formatDate = (d) => {
    if (!d) return 'N/A';
    return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };
  const getOverdueBadgeClass = (days) => {
    if (days === 0) return styles.overdueBadge0;
    if (days <= 30) return styles.overdueBadge30;
    return styles.overdueBadge90;
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className={styles.modalHeader}>
          <div>
            <h3 className={styles.modalTitle}>{vendor.vendorName}</h3>
            <p className={styles.modalSubtitle}>
              Code: {vendor.vendorCode} &nbsp;|&nbsp; Region: {vendor.region || 'Unknown'}
            </p>
          </div>
          <button onClick={onClose} className={styles.modalClose}>✕</button>
        </div>

        {/* Filters */}
        <div className={styles.modalFilters}>
          <div className={styles.modalSearchWrapper}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              type="text"
              placeholder="Search invoices..."
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(0); }}
              className={styles.modalSearchInput}
            />
            {searchTerm && (
              <button onClick={() => { setSearchTerm(''); setCurrentPage(0); }} className={styles.clearSearchButton}>✕</button>
            )}
          </div>
          <button onClick={handleExport} disabled={filteredInvoices.length === 0} className={styles.excelButton}>
            📊 Export Excel
          </button>
          {!loading && (
            <div className={styles.modalRecordCount}>
              {filteredInvoices.length} record{filteredInvoices.length !== 1 ? 's' : ''}
            </div>
          )}
        </div>

        {/* Body */}
        <div className={styles.modalBody}>
          {loading && (
            <div className={styles.loadingContainer}>
              <div className={styles.loadingSpinner} />
              <div className={styles.loadingText}>Loading invoices...</div>
            </div>
          )}
          {error && <div className={styles.errorMessage}>{error}</div>}
          {!loading && (
            <div className={styles.tableWrapper}>
              <table className={styles.modalTable}>
                <thead>
                  <tr>
                    <th className={styles.th}>Invoice No.</th>
                    <th className={styles.th}>Invoice Date</th>
                    <th className={styles.th}>Vendor Ref No</th>
                    <th className={styles.th}>Vendor Code</th>
                    <th className={styles.th}>Vendor Name</th>
                    <th className={styles.th}>Contact Person</th>
                    <th className={styles.th}>Invoice Total</th>
                    <th className={styles.th}>Balance Due</th>
                    <th className={styles.th}>Country</th>
                    <th className={styles.th}>State</th>
                    <th className={styles.th}>Region</th>
                    <th className={styles.th}>Overdue Days</th>
                    <th className={styles.th}>Payment Terms</th>
                    <th className={styles.th}>Supply Date</th>
                    <th className={styles.th}>Sales Person</th>
                    <th className={styles.th}>Master Sales Person</th>
                    <th className={styles.th}>Payment Status</th>
                  </tr>
                </thead>
                <tbody>
                  {displayInvoices.length > 0 ? displayInvoices.map((inv, i) => (
                    <tr key={`${inv.invoiceNo}-${i}`} className={styles.tr}>
                      <td className={styles.td}>{inv.invoiceNo}</td>
                      <td className={styles.td}>{formatDate(inv.invoiceDate)}</td>
                      <td className={styles.td}>{inv.vendorRefNo || 'N/A'}</td>
                      <td className={styles.td}>{inv.vendorCode}</td>
                      <td className={styles.td}>{inv.vendorName}</td>
                      <td className={styles.td}>{inv.contactPerson || 'N/A'}</td>
                      <td className={styles.td}>{formatCurrency(inv.invoiceTotal)}</td>
                      <td className={styles.td}>
                        <span className={`${styles.balanceDue} ${inv.balanceDue > 0 ? styles.balanceDueOverdue : styles.balanceDueNormal}`}>
                          {formatCurrency(inv.balanceDue)}
                        </span>
                      </td>
                      <td className={styles.td}>{inv.country}</td>
                      <td className={styles.td}>{inv.state}</td>
                      <td className={styles.td}>{inv.region || 'Unknown'}</td>
                      <td className={styles.td}>
                        <span className={`${styles.overdueBadge} ${getOverdueBadgeClass(inv.overdueDays)}`}>
                          {inv.overdueDays} days
                        </span>
                      </td>
                      <td className={styles.td}>{inv.paymentTerms}</td>
                      <td className={styles.td}>{formatDate(inv.supplyDate)}</td>
                      <td className={styles.td}>{inv.salesPerson || 'N/A'}</td>
                      <td className={styles.td}>{inv.masterSalesPerson || 'N/A'}</td>
                      <td className={styles.td}>
                        <span className={`${styles.paymentStatus} ${inv.paymentStatus === 'Received' ? styles.paymentStatusReceived : styles.paymentStatusPending}`}>
                          {inv.paymentStatus}
                        </span>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="17" className={styles.td} style={{ textAlign: 'center', padding: '40px' }}>
                        No invoices found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Pagination */}
        {!loading && filteredInvoices.length > itemsPerPage && (
          <div className={styles.modalPagination}>
            <div className={styles.paginationInfo}>
              Showing {currentPage * itemsPerPage + 1}–{Math.min((currentPage + 1) * itemsPerPage, filteredInvoices.length)} of {filteredInvoices.length} records
            </div>
            <div className={styles.paginationControls}>
              <button onClick={() => setCurrentPage(0)} disabled={currentPage === 0} className={styles.paginationButton}>First</button>
              <button onClick={() => setCurrentPage(p => Math.max(0, p - 1))} disabled={currentPage === 0} className={styles.paginationButton}>Prev</button>
              <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
              <button onClick={() => setCurrentPage(p => Math.min(totalPages - 1, p + 1))} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Next</button>
              <button onClick={() => setCurrentPage(totalPages - 1)} disabled={currentPage === totalPages - 1} className={styles.paginationButton}>Last</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
// VendorList — used by Local & Overseas tabs
// ─────────────────────────────────────────────────────────────
const VendorList = ({ type }) => {
  const [allVendors, setAllVendors]           = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [searchTerm, setSearchTerm]           = useState('');
  const [suggestions, setSuggestions]         = useState([]);
  const [showDropdown, setShowDropdown]       = useState(false);
  const [loading, setLoading]                 = useState(true);
  const [error, setError]                     = useState(null);
  const [modalVendor, setModalVendor]         = useState(null);
  const dropdownRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => { fetchVendors(); }, [type]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setShowDropdown(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => { applySearch(); }, [allVendors, searchTerm]);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    if (!searchTerm.trim()) { setSuggestions([]); setShowDropdown(false); return; }
    debounceRef.current = setTimeout(() => {
      const s = searchTerm.toLowerCase();
      const matched = allVendors.filter(v => v.vendorName?.toLowerCase().includes(s)).slice(0, 10);
      setSuggestions(matched);
      setShowDropdown(matched.length > 0);
    }, 200);
    return () => clearTimeout(debounceRef.current);
  }, [searchTerm, allVendors]);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      setError(null);
      setSearchTerm('');
      const data = await vendorBalanceApi.getTopOutstanding('');
      const filtered = type === 'local'
        ? data.filter(v => v.country === 'IN')
        : data.filter(v => v.country !== 'IN');
      setAllVendors(filtered);
      setFilteredVendors(filtered);
    } catch { setError('Failed to load vendors'); }
    finally { setLoading(false); }
  };

  const applySearch = () => {
    if (!searchTerm.trim()) { setFilteredVendors(allVendors); return; }
    const s = searchTerm.toLowerCase();
    setFilteredVendors(allVendors.filter(v =>
      v.vendorName?.toLowerCase().includes(s) ||
      v.vendorCode?.toLowerCase().includes(s) ||
      v.state?.toLowerCase().includes(s) ||
      v.region?.toLowerCase().includes(s)
    ));
  };

  const handleSuggestionSelect = (v) => {
    setSearchTerm(v.vendorName);
    setShowDropdown(false);
    setSuggestions([]);
  };

  const handleExportExcel = () => {
    if (filteredVendors.length === 0) { alert('No data to export'); return; }
    const exportData = filteredVendors.map((v, i) => ({
      'Rank': i + 1, 'Vendor Code': v.vendorCode, 'Vendor Name': v.vendorName,
      'Country': v.country, 'State': v.state, 'Region': v.region || 'Unknown',
      'Total Outstanding': v.totalOutstanding, 'Overdue Amount': v.overdueAmount,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, type === 'local' ? 'Local Vendors' : 'Overseas Vendors');
    XLSX.writeFile(wb, `${type}_vendor_outstanding.xlsx`);
  };

  const formatCurrency = (v) =>
    '₹' + (v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const totalOutstanding = filteredVendors.reduce((s, v) => s + v.totalOutstanding, 0);
  const totalOverdue     = filteredVendors.reduce((s, v) => s + (v.overdueAmount || 0), 0);

  return (
    <div>
      <div className={styles.filtersSection}>
        <div className={styles.searchRow}>
          <div className={styles.searchGroup} ref={dropdownRef}>
            <label className={styles.filterLabel}>Search Vendor:</label>
            <div className={styles.searchInputWrapper}>
              <span className={styles.searchIcon}>🔍</span>
              <input
                type="text"
                placeholder="Type to filter vendors..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => suggestions.length > 0 && setShowDropdown(true)}
                className={styles.searchInput}
                disabled={loading}
              />
              {searchTerm && (
                <button onClick={() => { setSearchTerm(''); setShowDropdown(false); }} className={styles.clearSearchButton}>✕</button>
              )}
              {showDropdown && suggestions.length > 0 && (
                <div className={styles.dropdownMenu}>
                  {suggestions.map(s => (
                    <div key={s.vendorCode} onClick={() => handleSuggestionSelect(s)} className={styles.dropdownItem}>
                      <div className={styles.dropdownItemName}>{s.vendorName}</div>
                      <div className={styles.dropdownItemCode}>Code: {s.vendorCode}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={styles.buttonGroup}>
            <button onClick={handleExportExcel} disabled={loading || filteredVendors.length === 0} className={styles.excelButton}>
              📊 Export Excel
            </button>
          </div>
        </div>

        {!loading && allVendors.length > 0 && (
          <div className={styles.summaryRow}>
            <div className={styles.summaryText}>
              {searchTerm
                ? <>Found <strong>{filteredVendors.length}</strong> of <strong>{allVendors.length}</strong> vendors</>
                : <>Found <strong>{allVendors.length}</strong> vendor{allVendors.length !== 1 ? 's' : ''}</>
              }
            </div>
            <div className={styles.totalAmounts}>
              <div className={styles.totalOverdue}>Total Overdue: <span className={styles.amountRed}>{formatCurrency(totalOverdue)}</span></div>
              <div className={styles.totalOutstanding}>Total Balance: <span className={styles.amountBlue}>{formatCurrency(totalOutstanding)}</span></div>
            </div>
          </div>
        )}
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}

      {loading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} />
          <div className={styles.loadingText}>Loading {type} vendors...</div>
        </div>
      )}

      {!loading && filteredVendors.length === 0 && (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>{type === 'local' ? '🏭' : '🌍'}</div>
          <h3 className={styles.emptyTitle}>No Vendors Found</h3>
          <p className={styles.emptyText}>
            {searchTerm ? 'No vendors match your search' : `No ${type} vendors with outstanding balance`}
          </p>
        </div>
      )}

      {!loading && filteredVendors.length > 0 && (
        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th}>#</th>
                  <th className={styles.th}>Vendor Code</th>
                  <th className={`${styles.th} ${styles.thVendorName}`}>Vendor Name</th>
                  <th className={styles.th}>Country</th>
                  <th className={styles.th}>State</th>
                  <th className={styles.th}>Region</th>
                  <th className={`${styles.th} ${styles.thRight}`}>Overdue Amount</th>
                  <th className={`${styles.th} ${styles.thRight}`}>Total Outstanding</th>
                </tr>
              </thead>
              <tbody>
                {filteredVendors.map((v, index) => (
                  <tr
                    key={`${v.vendorCode}-${index}`}
                    className={`${styles.tr} ${styles.trClickable}`}
                    onClick={() => setModalVendor(v)}
                    title="Click to view invoices"
                  >
                    <td className={styles.td}><span className={styles.rank}>#{index + 1}</span></td>
                    <td className={styles.td}><span className={styles.vendorCode}>{v.vendorCode}</span></td>
                    <td className={styles.td}><span className={styles.vendorName}>{v.vendorName}</span></td>
                    <td className={styles.td}>{v.country || 'N/A'}</td>
                    <td className={styles.td}>{v.state || 'N/A'}</td>
                    <td className={styles.td}>
                      <span className={`${styles.regionBadge} ${v.region ? styles.regionBadgeFilled : styles.regionBadgeEmpty}`}>
                        {v.region || 'Unknown'}
                      </span>
                    </td>
                    <td className={`${styles.td} ${styles.tdRight}`}>
                      <span className={`${styles.overdueAmount} ${(v.overdueAmount || 0) > 0 ? styles.overdueAmountActive : ''}`}>
                        {formatCurrency(v.overdueAmount || 0)}
                      </span>
                    </td>
                    <td className={`${styles.td} ${styles.tdRight}`}>
                      <span className={styles.outstandingAmount}>{formatCurrency(v.totalOutstanding)}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modalVendor && <InvoiceModal vendor={modalVendor} onClose={() => setModalVendor(null)} />}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────
const VendorTopOutstanding = () => {
  const [activeTab, setActiveTab] = useState('search');

  // Search tab state
  const [searchTerm, setSearchTerm]           = useState('');
  const [suggestions, setSuggestions]         = useState([]);
  const [showDropdown, setShowDropdown]       = useState(false);
  const [selectedVendor, setSelectedVendor]   = useState(null);
  const [vendors, setVendors]                 = useState([]);
  const [loading, setLoading]                 = useState(false);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [error, setError]                     = useState(null);
  const [hasSearched, setHasSearched]         = useState(false);
  const [modalVendor, setModalVendor]         = useState(null);

  const dropdownRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setShowDropdown(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!searchTerm.trim() || selectedVendor) { setSuggestions([]); setShowDropdown(false); return; }
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      try {
        setSuggestionsLoading(true);
        const data = await vendorBalanceApi.getTopOutstanding(searchTerm.trim());
        const unique = [];
        const seen = new Set();
        data.forEach(v => { if (!seen.has(v.vendorCode)) { seen.add(v.vendorCode); unique.push(v); } });
        setSuggestions(unique.slice(0, 10));
        setShowDropdown(true);
      } catch { setSuggestions([]); }
      finally { setSuggestionsLoading(false); }
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [searchTerm, selectedVendor]);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setSelectedVendor(null);
    setVendors([]);
    setHasSearched(false);
  };

  const handleSuggestionSelect = async (suggestion) => {
    setSearchTerm(suggestion.vendorName);
    setSelectedVendor(suggestion);
    setShowDropdown(false);
    setSuggestions([]);
    await fetchOutstanding(suggestion.vendorName);
  };

  const fetchOutstanding = async (name) => {
    try {
      setLoading(true); setError(null); setHasSearched(true);
      const data = await vendorBalanceApi.getTopOutstanding(name);
      setVendors(data);
    } catch { setError('Failed to fetch vendor data'); setVendors([]); }
    finally { setLoading(false); }
  };

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;
    setShowDropdown(false);
    await fetchOutstanding(searchTerm.trim());
  };

  const handleClear = () => {
    setSearchTerm(''); setSelectedVendor(null); setVendors([]);
    setSuggestions([]); setHasSearched(false); setError(null); setShowDropdown(false);
  };

  const handleExportExcel = () => {
    if (vendors.length === 0) { alert('No data to export'); return; }
    const exportData = vendors.map((v, i) => ({
      'Rank': i + 1, 'Vendor Code': v.vendorCode, 'Vendor Name': v.vendorName,
      'Country': v.country, 'State': v.state, 'Region': v.region || 'Unknown',
      'Total Outstanding': v.totalOutstanding, 'Overdue Amount': v.overdueAmount,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Vendor Outstanding');
    XLSX.writeFile(wb, `vendor_outstanding_${searchTerm.replace(/\s+/g, '_')}.xlsx`);
  };

  const formatCurrency = (v) =>
    '₹' + (v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const totalOutstanding = vendors.reduce((s, v) => s + v.totalOutstanding, 0);
  const totalOverdue     = vendors.reduce((s, v) => s + (v.overdueAmount || 0), 0);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.pageTitle}>Top Outstanding Vendors</h2>
      </div>

      {/* Sub Tabs */}
      <div className={styles.subTabs}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`${styles.subTabButton} ${activeTab === tab.key ? styles.subTabButtonActive : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ── Search Tab ── */}
      {activeTab === 'search' && (
        <div>
          <div className={styles.filtersSection}>
            <div className={styles.searchRow}>
              <div className={styles.searchGroup} ref={dropdownRef}>
                <label className={styles.filterLabel}>Search Vendor:</label>
                <div className={styles.searchInputWrapper}>
                  <span className={styles.searchIcon}>🔍</span>
                  <input
                    type="text"
                    placeholder="Type vendor name..."
                    value={searchTerm}
                    onChange={handleInputChange}
                    onFocus={() => suggestions.length > 0 && setShowDropdown(true)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                    className={styles.searchInput}
                    disabled={loading}
                  />
                  {searchTerm && <button onClick={handleClear} className={styles.clearSearchButton}>✕</button>}

                  {showDropdown && (
                    <div className={styles.dropdownMenu}>
                      {suggestionsLoading && <div className={styles.dropdownLoading}>Searching...</div>}
                      {!suggestionsLoading && suggestions.map(s => (
                        <div key={s.vendorCode} onClick={() => handleSuggestionSelect(s)}
                          className={`${styles.dropdownItem} ${selectedVendor?.vendorCode === s.vendorCode ? styles.dropdownItemActive : ''}`}>
                          <div className={styles.dropdownItemName}>{s.vendorName}</div>
                          <div className={styles.dropdownItemCode}>Code: {s.vendorCode}</div>
                        </div>
                      ))}
                      {!suggestionsLoading && suggestions.length === 0 && searchTerm && (
                        <div className={styles.dropdownNoResults}>No vendors found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.buttonGroup}>
                <button onClick={handleSearch} disabled={loading || !searchTerm.trim()} className={styles.searchButton}>Search</button>
                {vendors.length > 0 && (
                  <button onClick={handleExportExcel} disabled={loading} className={styles.excelButton}>📊 Export Excel</button>
                )}
              </div>
            </div>

            {vendors.length > 0 && (
              <div className={styles.summaryRow}>
                <div className={styles.summaryText}>Found <strong>{vendors.length}</strong> vendor{vendors.length !== 1 ? 's' : ''}</div>
                <div className={styles.totalAmounts}>
                  <div className={styles.totalOverdue}>Total Overdue: <span className={styles.amountRed}>{formatCurrency(totalOverdue)}</span></div>
                  <div className={styles.totalOutstanding}>Total Balance: <span className={styles.amountBlue}>{formatCurrency(totalOutstanding)}</span></div>
                </div>
              </div>
            )}
          </div>

          {error && <div className={styles.errorMessage}>{error}</div>}

          {loading && (
            <div className={styles.loadingContainer}>
              <div className={styles.loadingSpinner} />
              <div className={styles.loadingText}>Searching vendors...</div>
            </div>
          )}

          {!loading && !hasSearched && (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>🏢</div>
              <h3 className={styles.emptyTitle}>Search for a Vendor</h3>
              <p className={styles.emptyText}>Type a vendor name above to view outstanding balance details</p>
            </div>
          )}

          {!loading && hasSearched && vendors.length === 0 && (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>📊</div>
              <h3 className={styles.emptyTitle}>No Vendors Found</h3>
              <p className={styles.emptyText}>No vendors match your search term</p>
            </div>
          )}

          {!loading && vendors.length > 0 && (
            <div className={styles.tableContainer}>
              <div className={styles.tableWrapper}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th className={styles.th}>#</th>
                      <th className={styles.th}>Vendor Code</th>
                      <th className={`${styles.th} ${styles.thVendorName}`}>Vendor Name</th>
                      <th className={styles.th}>Country</th>
                      <th className={styles.th}>State</th>
                      <th className={styles.th}>Region</th>
                      <th className={`${styles.th} ${styles.thRight}`}>Overdue Amount</th>
                      <th className={`${styles.th} ${styles.thRight}`}>Total Outstanding</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendors.map((v, index) => (
                      <tr
                        key={`${v.vendorCode}-${index}`}
                        className={`${styles.tr} ${styles.trClickable}`}
                        onClick={() => setModalVendor(v)}
                        title="Click to view invoices"
                      >
                        <td className={styles.td}><span className={styles.rank}>#{index + 1}</span></td>
                        <td className={styles.td}><span className={styles.vendorCode}>{v.vendorCode}</span></td>
                        <td className={styles.td}><span className={styles.vendorName}>{v.vendorName}</span></td>
                        <td className={styles.td}>{v.country || 'N/A'}</td>
                        <td className={styles.td}>{v.state || 'N/A'}</td>
                        <td className={styles.td}>
                          <span className={`${styles.regionBadge} ${v.region ? styles.regionBadgeFilled : styles.regionBadgeEmpty}`}>
                            {v.region || 'Unknown'}
                          </span>
                        </td>
                        <td className={`${styles.td} ${styles.tdRight}`}>
                          <span className={`${styles.overdueAmount} ${(v.overdueAmount || 0) > 0 ? styles.overdueAmountActive : ''}`}>
                            {formatCurrency(v.overdueAmount || 0)}
                          </span>
                        </td>
                        <td className={`${styles.td} ${styles.tdRight}`}>
                          <span className={styles.outstandingAmount}>{formatCurrency(v.totalOutstanding)}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {modalVendor && <InvoiceModal vendor={modalVendor} onClose={() => setModalVendor(null)} />}
        </div>
      )}

      {activeTab === 'local'    && <VendorList type="local" />}
      {activeTab === 'overseas' && <VendorList type="overseas" />}
    </div>
  );
};

export default VendorTopOutstanding;